import { render, staticRenderFns } from "./TraineeListView.vue?vue&type=template&id=372af237&"
import script from "./TraineeListView.vue?vue&type=script&lang=js&"
export * from "./TraineeListView.vue?vue&type=script&lang=js&"
import style0 from "./TraineeListView.vue?vue&type=style&index=0&id=372af237&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports